// extracted by mini-css-extract-plugin
export default {"avatars":"styles_avatars__F9b9P","avatar":"styles_avatar__lpMPL"};